const DEFAULT_FALLBACK = "Something went wrong. Please try again."

function joinErrors(errors) {
  if (!Array.isArray(errors) || errors.length === 0) return null
  const parts = errors.map(e => {
    if (typeof e === "string") return e
    if (e && typeof e === "object") {
      return e.detail || e.title || e.message || ""
    }
    return ""
  }).filter(Boolean)
  return parts.length ? parts.join(" ") : null
}

function extractFromData(data) {
  if (data == null) return null

  if (typeof data === "string") {
    try {
      const parsed = JSON.parse(data)
      return extractFromData(parsed)
    } catch {
      return data.trim() ? data : null
    }
  }

  if (typeof data === "object") {
    const fromArray = joinErrors(data.errors)
    if (fromArray) return fromArray
    if (typeof data.error === "string" && data.error) return data.error
    if (typeof data.message === "string" && data.message) return data.message
  }

  return null
}

export function extractApiErrorMessage(err, fallback = DEFAULT_FALLBACK) {
  if (err == null) return fallback

  const candidates = [err, err?.error].filter(Boolean)

  let result = fallback
  candidates.some(root => {
    const fromBody = extractFromData(root?.response?.data)
    if (fromBody) {
      result = fromBody
      return true
    }
    if (typeof root?.message === "string" && root.message) {
      result = root.message
      return true
    }
    return false
  })

  return result
}

export const API_ERROR_FALLBACK = DEFAULT_FALLBACK

export const MAIN_TOAST_OPTIONS = Object.freeze({
  toastId: "container-inner",
  containerId: "main"
})
